import { gql } from "@apollo/client";

import { VENUE_USER_FRAGMENT } from "./fragments/venueUser";

export const VENUE_USER_CREATE_MUTATION = gql`
  ${VENUE_USER_FRAGMENT}
  mutation VenueUserCreate($input: VenueUserCreateInput!) {
    venueUserCreate(input: $input) {
      ...VenueUser
    }
  }
`;

export const VENUE_USER_UPDATE_MUTATION = gql`
  ${VENUE_USER_FRAGMENT}
  mutation VenueUserUpdate($id: Int!, $input: VenueUserUpdateInput!) {
    venueUserUpdate(id: $id, input: $input) {
      ...VenueUser
    }
  }
`;

export const VENUE_USER_DELETE_MUTATION = gql`
  ${VENUE_USER_FRAGMENT}
  mutation VenueUserDelete($id: Int!) {
    venueUserDelete(id: $id) {
      ...VenueUser
    }
  }
`;
